export default __webpack_public_path__ + "static/media/002-cutlery.ffa6a89f.svg";